import React, { useState } from 'react';
import './index.scss';

const SectionHeader = ({ title, descriptions, onClickButton, isComingSoon }) => {
    return (
        <div className="section-header-container">
            <div className="section-header-left-side" >
                <div className="section-header-title">
                    {title}
                    {isComingSoon && <span className="section-header-coming-soon">{"COMING SOON"}</span>}
                </div>
                <div className="section-header-description">
                    {
                        descriptions.map((description, index) => (
                            <span key={index}>{description}</span>
                        ))
                    }
                </div>
            </div>
            <div className="section-header-right-side">
                <div className="section-header-button" onClick={onClickButton}>
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/v2/landing2025/play-button.svg" alt="btn" />
                </div>
            </div>
        </div>
    )
}

export default SectionHeader;